import {Box, Checkbox, Collapse, Flex, Heading, IconButton, Stack, Text, VStack} from "@chakra-ui/react";
import {CustomCheckbox, StyledButton} from "../../components";
import {ReactComponent as ArrowUp} from "../../assets/icons/arrow-up.svg";
import {ReactComponent as ArrowDown} from "../../assets/icons/arrow-down.svg";
import {ReactComponent as ArrowRight} from "../../assets/icons/arrow_right.svg";
import {ReactComponent as Lock} from "../../assets/icons/lock.svg";
import {useState} from "react";
import {TutorialsCategories, TutorialsData} from "../../helpers/data-jsons";
import {Link} from "react-router-dom";

const Tutorials = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [openId, setOpenId] = useState(null);
    const [categories, setCategories] = useState(TutorialsCategories);
    const [tutorialsData, setTutorialsData] = useState(TutorialsData);
    const toggleOpen = (id) => {
        setOpenId(openId === id ? null : id);
    };
    const handleToggleTag = (id) => {
        setCategories(prev =>
            prev.map(categories =>
                categories.id === id ? {...categories, checked: !categories.checked} : categories
            )
        );
    };
    return (
        <Stack
            maxW={'1344px'}
            margin={'auto'}
            fontSize={'24px'}
            fontWeight={'500'}
            color={'neutral.100'}
            p={{base: '0', md: '24px 16px'}}
        >
            <Heading
                p={{base: '20px 16px 0 16px', md: ''}}
                fontSize={'24px'}
            >
                Tutorials
            </Heading>
            <VStack
                bg={'neutral.1100'}
                p={{base: '16px', xm: '32px'}}
                gap={'40px'}
                borderRadius={'16px'}
            >
                <Flex
                    w={'100%'}
                    gap={'16px'}
                    flexDirection={{base: 'column', xm: 'row'}}
                >
                    <VStack
                        minW={'254px'}
                        borderRadius={'16px'}
                        gap={'16px'}
                        p={'16px'}
                        border={'solid 1px #5834A8'}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        maxH={'max-content'}
                    >
                        <Heading
                            w={'full'}
                            fontSize={'18px'}
                            fontWeight={'500'}
                        >Categories</Heading>
                        <Flex
                            borderBottom={'solid 1px'}
                            borderColor={'neutral.800'}
                            minH={'40px'}
                            w={'full'}
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                        >
                            <Flex
                                gap={'4px'}
                                fontSize={'12px'}
                                fontWeight={'400'}>All <CustomCheckbox
                                background={'#5834A8'}
                                width={'16px'}
                                height={'16px'}/>
                            </Flex>
                            <Flex
                                gap={'4px'}
                                fontSize={'12px'}
                                fontWeight={'400'}>Beginer<CustomCheckbox
                                background={'#5834A8'}
                                width={'16px'}
                                height={'16px'}/></Flex>
                            <Flex
                                gap={'4px'}
                                fontSize={'12px'}
                                fontWeight={'400'}>Intermediate<CustomCheckbox
                                background={'#5834A8'}
                                width={'16px'}
                                height={'16px'}/></Flex>
                        </Flex>
                        <VStack
                            w={'full'}
                            flexWrap={'wrap'}
                            alignItems={'flex-start'}
                            gap={'16px'}
                            flexDirection={{base: 'row', xm: 'column'}}
                        >
                            {
                                categories.map((categories) => (
                                    <StyledButton
                                        margin={{base: 'auto', xm: 'unset'}}
                                        key={categories.id}
                                        height={'32px'}
                                        fontSize={'14px'}
                                        textColor={'neutral.100'}
                                        width={'92px'}
                                        fontWeight={'200'}
                                        onClick={() => handleToggleTag(categories.id)}
                                        border={'solid 1px #353945'}
                                        bg={categories.checked ? 'purple.500' : 'neutral.900'}
                                    >{categories.title}</StyledButton>

                                ))
                            }
                        </VStack>
                        <hr style={{border: '1px solid rgba(53, 57, 69, 1)', width: '100%'}}/>
                        <VStack
                            w={'full'}
                        >
                            <StyledButton
                                height={'32px'}
                                w={'full'}
                                bg={'#6F41D240'}
                            >
                                Reset
                            </StyledButton>
                        </VStack>
                    </VStack>
                    <VStack
                        maxW={'1010px'}
                        gap={'16px'}
                        w={'full'}
                    >
                        {
                            TutorialsData.map((data) => (
                                <Box
                                    key={data.id}
                                    w={'full'}
                                    bg={'neutral.1000'}
                                    borderRadius={'8px'}
                                    p={{base:'24px 5px',md:'24px 16px'}}
                                    color={'neutral.500'}
                                >
                                    <Flex
                                        justify={"space-between"}
                                        align={"center"}
                                        cursor={"pointer"}
                                        onClick={() => setOpenId(openId === data.id ? null : data.id)} // toggle logic
                                    >
                                        <Heading
                                            fontSize={'18px'}
                                            fontWeight={'700'}>
                                            {data.title}
                                        </Heading>

                                        {openId === data.id ? <ArrowUp/> : <ArrowDown/>}
                                    </Flex>
                                    <Collapse in={openId === data.id} animateOpacity>
                                        <Box>
                                            <Flex>
                                                <Box w={'full'}>
                                                    {data.lesson.map((lessons, idx) => (
                                                        <Flex
                                                            key={`${data.id}-${lessons.id || idx}`} // unique key
                                                            minH={'64px'}
                                                            p={{base: '0', md: '0 16px 0px 32px'}}
                                                            justifyContent={'space-between'}
                                                            alignItems={'center'}
                                                        >
                                                            <Flex
                                                                flexDirection={{base: 'column', md: 'row'}}
                                                                gap={'16px'}
                                                                maxW={{base:'212px',sm:'75%',md:'100%'}}
                                                            >
                                                                <Text color={'purple.500'} fontSize={'16px'}
                                                                      fontWeight={'400'}>
                                                                    Lesson:{idx + 1}
                                                                </Text>
                                                                <Text
                                                                    textDecoration={'underline'}
                                                                    fontSize={{base: '12px', '2sm': '16px'}}
                                                                    fontWeight={'400'}
                                                                >
                                                                    {lessons.title || 'Untitled Lesson'}
                                                                </Text>
                                                            </Flex>
                                                            {lessons.url ? (
                                                                <StyledButton
                                                                    p={'0 12px'}
                                                                    fontSize={{base: '12px', '2sm': '16px'}}
                                                                    gap={'4px'}
                                                                    width={'fit-content'}
                                                                    height={'40px'}
                                                                    bg={'transparent'}
                                                                >
                                                                    <Box
                                                                        fontSize={{base: '12px', md: '16px'}}
                                                                        as={Link}
                                                                        to={'/tutorial/' + data.id + '/' + lessons.id}
                                                                    >Read more</Box>
                                                                    <ArrowRight/>
                                                                </StyledButton>
                                                            ) : (
                                                                <StyledButton
                                                                    padding={'0'}
                                                                    shadowHoverColor={'unset'}
                                                                    hoverBg={'unset'}
                                                                    gap={'8px'}
                                                                    width={'fit-content'}
                                                                    textColor={'purple.500'}
                                                                    height={'40px'}
                                                                    bg={'transparent'}
                                                                >
                                                                    <Box
                                                                        fontSize={{base: '12px', md: '16px'}}
                                                                    >Buy Plan</Box>
                                                                    <Box>
                                                                        <Lock/>
                                                                    </Box>
                                                                </StyledButton>
                                                            )}
                                                        </Flex>
                                                    ))}
                                                </Box>
                                            </Flex>
                                        </Box>
                                    </Collapse>
                                </Box>
                            ))
                        }


                    </VStack>
                </Flex>
            </VStack>
        </Stack>
    )
}
export default Tutorials